import { isEmpty } from "lodash";
import { E_ChannelOptions } from "../../globalTypes/GlobalTypes";
import { R_GeneralElementsRoutes } from "../../utils/Routes";

export const ALLOWED_CHANNELS = [
  E_ChannelOptions.SUPER_APP,
  E_ChannelOptions.ONE_ABC,
  E_ChannelOptions.ABSLI,
  E_ChannelOptions.ABHI,
  E_ChannelOptions.ABSLAMC,
  E_ChannelOptions.ABML,
  E_ChannelOptions.ABHFL,
  E_ChannelOptions.ABFL,
];

export const resolveMobileNumber = ({
  channel,
  ssoMobileNo,
  loginMobileNo,
  localStorageMobileNo,
}: {
  channel: E_ChannelOptions | undefined;
  ssoMobileNo?: string;
  loginMobileNo?: string;
  localStorageMobileNo?: string;
}) => {
  return ALLOWED_CHANNELS.includes(channel as E_ChannelOptions)
    ? ssoMobileNo
    : loginMobileNo || localStorageMobileNo;
};

export const getAuthPassed = ({
  popupError,
  customerAndLobDetails,
  longSessionAuthToken,
  decidingNextRoute,
}: {
  popupError: boolean;
  customerAndLobDetails: unknown;
  longSessionAuthToken?: string;
  decidingNextRoute: boolean;
}) => {
  if (popupError) {
    return false;
  }

  return !(
    !customerAndLobDetails ||
    isEmpty(customerAndLobDetails) ||
    !longSessionAuthToken ||
    decidingNextRoute
  );
};

export const getShowGuardFallback = ({
  pathname,
  customerAndLobDetails,
  longSessionAuthToken,
  decidingNextRoute,
}: {
  pathname: string;
  customerAndLobDetails: unknown;
  longSessionAuthToken?: string;
  decidingNextRoute: boolean;
}) => {
  return (
    R_GeneralElementsRoutes.setMpin !== pathname &&
    (!customerAndLobDetails || !longSessionAuthToken || decidingNextRoute)
  );
};
